(ns pfo.link.model (:require [pfo.api :as api]
                             [ajax.formats :refer [raw-response-format]]
                             [pfo.util :as util]))

(defn parent-params [parent-info]
  (when parent-info
    {:parent_id (:parent-id parent-info)
     :parent_type (:parent-type parent-info)
     :parent_complete_by (:complete-by parent-info)
     :parent_key (:key parent-info)
     :link "yes"}))

(defn task-links [id]
  (api/ajaxp (str "/links/task/" id "/") {}))

(defn occurrence-links [id complete_by task_type]
  (api/ajaxp (str "/links/occurrence/" id "/" complete_by "/" task_type "/") {}))

(defn document-links [id]
  (api/ajaxp (str "/links/document/" id "/") {}))

(defn children-by-ids [link-ids]
  (api/ajaxp (str "/links/children/?" (util/make-params (util/remove-nil-values {:id link-ids}))) {}))

(defn delete-link [parent-type parent-id child-type child-id]
  (api/ajaxp (str "/links/?" (util/make-params
                               (util/remove-nil-values {:parent_type parent-type
                                                        :parent_id parent-id
                                                        :child_type child-type
                                                        :child_id child-id})))
             {:method :delete}))

(defn add-link [parent-type parent-id parent-complete-by child-type child-id]
  (api/ajaxp "/links/"
             {:method :post
              :body (util/make-params
                      (util/remove-nil-values {:parent_type parent-type
                                               :parent_id parent-id
                                               :parent_complete_by parent-complete-by
                                               :child_type child-type
                                               :child_id child-id}))}))

(defn object [parent-type parent-id parent-complete-by]
  (api/ajaxp "/links/object/"
             {:method :get
              :params (util/remove-nil-values {:parent_type parent-type
                                               :parent_id parent-id
                                               :parent_complete_by parent-complete-by})}))
